import { render } from "./NewRoleComponent.vue?vue&type=template&id=40a60954"
import script from "./NewRoleComponent.vue?vue&type=script&lang=js"
export * from "./NewRoleComponent.vue?vue&type=script&lang=js"

import "./NewRoleComponent.vue?vue&type=style&index=0&id=40a60954&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__